import withSkeleton from '../../HOC/withSkeleton';
import AddressItem from '../AddressItem';
import AMLSummaryRow from '../AMLSummaryRow/AMLSummaryRow';
import CurrencyItem from '../CurrencyItem';
import HistoryItem from '../HistoryItem/HistoryItem';
import ListItem from '../ListItem';
import AddressSkeleton from './AddressSkeleton';
import ListItemSkeleton from './ListItemSkeleton';

export const CurrencyItemWithSkeleton = withSkeleton(ListItemSkeleton)(CurrencyItem, 'currency');
export const AddressItemWithSkeleton = withSkeleton(ListItemSkeleton)(AddressItem, 'address');
export const HistoryItemWithSkeleton = withSkeleton(ListItemSkeleton)(HistoryItem, 'transaction');
export const ListItemTextWithSkeleton = withSkeleton(AddressSkeleton)(ListItem, 'transaction');
export const AMLSummaryWithSkeleton = withSkeleton(ListItemSkeleton)(AMLSummaryRow, 'aml');
